import { createApi } from '@reduxjs/toolkit/query/react';
import { IBaseChosenTraitNode, IBaseTraitNode } from '../../../../../../shared/types/talentNodeTypes';
import { networkBaseQuery } from './utils';

type TCompareTalentLoadoutsParams = {
  loadoutTextA: string;
  loadoutTextB: string;
};

type TDecodedLoadout = {
  specId: number;
  heroSubTreeId: number;
  loadoutText: string;
  chosenNodes: IBaseChosenTraitNode[];
};

export type TCompareTalentLoadoutsResponse = {
  loadoutA: TDecodedLoadout;
  loadoutB: TDecodedLoadout;
  specNodes: IBaseTraitNode[];
};

export const talentCompareApi = createApi({
  reducerPath: 'talentCompareApi',
  baseQuery: networkBaseQuery,
  endpoints: (builder) => ({
    compareTalentLoadouts: builder.query<TCompareTalentLoadoutsResponse, TCompareTalentLoadoutsParams>({
      query: (params) => ({ url: '/api/talents/compare', params })
    })
  })
});

export const { useCompareTalentLoadoutsQuery } = talentCompareApi;
